// import {
// 	FAILED,

// } from "../actions/index.js";
import { SHOP_PLAN } from "../Component/Account/index";
import { STATUS_CHANGE } from "../Component/Dashboard/index";
const INITIAL_STATE = {
	error_msg: {},
	shop_plan: { loading: true },
	status_change: { loading: true },
};
const handleReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
	
		case SHOP_PLAN: {
            
			return Object.assign({}, state, {
				shop_plan: action.data && action.data.data && action.data.data.data,
			});
		}

		case STATUS_CHANGE: {
          
			return Object.assign({}, state, {
				status_change: action.data.data.data,
			});
		}


		default:
			return state;
	}
};
export default handleReducer;
